import type { ZuoraPaymentMethod } from '@kimuno/api-sdk';
import { Box } from '@mui/material';
import { useMemo } from 'react';

import type { ZuoraPaymentPageResponse } from '../../types/ZuoraPayments';
import PaypalForm from '../PaypalForm/PaypalForm';

interface PaymentPaypalContentProps {
	paypalToken: string;
	onResponseHandler: (paymentMethod: ZuoraPaymentMethod, response: ZuoraPaymentPageResponse) => void;
}

const PaymentPaypalContent = ({ paypalToken, onResponseHandler }: PaymentPaypalContentProps) => {
	const memoizedPaypalForm = useMemo(() => {
		return <PaypalForm token={paypalToken} licenceId={1} onResponse={onResponseHandler} />;
	}, [paypalToken, onResponseHandler]);

	return (
		<Box id="paypal_payment" data-testid="paypal-payment-content">
			{memoizedPaypalForm}
		</Box>
	);
};

export default PaymentPaypalContent;
